var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup18962(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.327,
    height: 46.327,
    viewBox: "0 0 46.327 46.327",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18962",
    "data-name": "Group 18962",
    transform: "translate(-383.345 -7031.622)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(386 7035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "linkedin_1_",
    "data-name": "linkedin (1)",
    d: "M23.164,0A23.164,23.164,0,1,0,46.327,23.164,23.166,23.166,0,0,0,23.164,0ZM16.433,35.017H10.791V18.045h5.641Zm-2.821-19.29h-.037a2.94,2.94,0,1,1,.074-5.864,2.941,2.941,0,1,1-.037,5.864Zm23.162,19.29H31.133v-9.08c0-2.282-.817-3.838-2.858-3.838a3.088,3.088,0,0,0-2.894,2.063,3.863,3.863,0,0,0-.186,1.377v9.478H19.555s.074-15.38,0-16.972H25.2v2.4a5.6,5.6,0,0,1,5.084-2.8c3.712,0,6.495,2.426,6.495,7.639Zm0,0",
    transform: "translate(383.345 7031.622)",
    fill: "#b5153a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup18962);
export default __webpack_public_path__ + "static/media/Group 18962.9b727bad4160356bcae0ea66055157fa.svg";
export { ForwardRef as ReactComponent };